export default __webpack_public_path__ + "static/media/tpc_calendar.d9f36f67.svg";